import { AbstractControl, ValidatorFn } from '@angular/forms';

export function DateIsSameOrAfter(date: AbstractControl): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        if (!control.value || !date.value)
            return null;

        const t1 = control.value;
        const t2 = date.value;

        if (t1.isSameOrAfter(t2))
            return null;

        return { 'invalidDate': {value: t1} };
    };
  }
